export const MODIFY_DATE_JOINED = 'MODIFY_DATE_JOINED';

export function modifyDateJoined(dateJoined){
    return{
        type: MODIFY_DATE_JOINED,
        mainState: {
            dateJoined: dateJoined
        }
    }
}